import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';

import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { LocationSubset } from '@era/stores';
import { ModelNamesFilter } from './model-names-filter';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-reboot-devices-modal-ui',
  templateUrl: './reboot-devices-modal.component.html',
  imports: [ReactiveFormsModule, FaIconComponent],
})
export class RebootDevicesModalComponent {
  private readonly formBuilder = inject(UntypedFormBuilder);

  public readonly locationSubset = input.required<LocationSubset>();
  public readonly submitFilters = output<ModelNamesFilter>();
  public readonly closeModal = output();
  public readonly rebootDevicesForm: UntypedFormGroup;
  private readonly modelNamesFilter = new ModelNamesFilter();
  modelChecked = false;

  LocationSubset = LocationSubset;

  public readonly rebootScopeMessage = computed(() => {
    const locationSubset = this.locationSubset();

    if (locationSubset === LocationSubset.All) {
      return "The 'reboot' command will be sent to all Devices of this Location, regardless of the Device Health State.";
    }

    return `The 'reboot' command will be sent to all Devices of the '${LocationSubset[locationSubset]}' Subset, regardless of the Device Health State.`;
  });

  constructor() {
    this.rebootDevicesForm = this.formBuilder.group(this.modelNamesFilter);
    this.rebootDevicesForm.setValidators(this.validateCheckboxes());
  }

  validateCheckboxes() {
    return (formGroup: UntypedFormGroup) => {
      let checked = 0;

      Object.keys(formGroup.controls).forEach((key) => {
        const control = formGroup.controls[key];
        if (control.value) {
          checked += 1;
        }
      });

      if (checked === 0) {
        return { requireOneDeviceModelChecked: true };
      }

      return null;
    };
  }

  closingModal() {
    this.closeModal.emit();
  }

  onSubmit() {
    this.modelNamesFilter.AppleTV = this.rebootDevicesForm.get('AppleTV')?.value;
    this.modelNamesFilter.iPad = this.rebootDevicesForm.get('iPad')?.value;
    this.modelNamesFilter.iPhone = this.rebootDevicesForm.get('iPhone')?.value;
    this.modelNamesFilter.iPod = this.rebootDevicesForm.get('iPod')?.value;

    this.submitFilters.emit(this.modelNamesFilter);

    this.rebootDevicesForm.reset();
    this.closingModal();
  }
}
